import { render, staticRenderFns } from "./lazyblock_about_us.vue?vue&type=template&id=719e3057&scoped=true"
import script from "./lazyblock_about_us.vue?vue&type=script&lang=js"
export * from "./lazyblock_about_us.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_about_us.vue?vue&type=style&index=0&id=719e3057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719e3057",
  null
  
)

export default component.exports